import { useLanguage } from '../../i18n/LanguageContext';

interface MissingFieldsHintProps {
  /** Human-readable labels of the required fields still missing. */
  missing: string[];
}

/**
 * Onboarding validation hint (#430): instead of leaving the Continue button disabled
 * with no explanation, tell the partner exactly which mandatory field(s) are still
 * missing. Renders nothing when everything required is filled in.
 */
export default function MissingFieldsHint({ missing }: MissingFieldsHintProps) {
  const { t } = useLanguage();
  if (missing.length === 0) return null;
  const prefix = t('onboarding.validation.missingPrefix') || 'Please complete the required field(s):';
  return (
    <div
      role="alert"
      className="wizard-validation-hint"
      style={{ fontSize: '0.8rem', color: '#dc2626', marginTop: '0.5rem' }}
    >
      {prefix} {missing.join(', ')}
    </div>
  );
}
